const apiTypeMap = {
	/**
	 * 所有三方API信息-只提供数据,不需要改变状态
	 * 适用于 一级菜单,二级菜单,内页
	 * API主要分3层 Type层,Api层,Game层; 彩票和电子的Game是从后端返回的
	 */
	1: {
		id: 1,
		name: "彩票",
		link: { name: "Racing", query: { id: 2023, index: 2 } },
		api: [
			/*这里要注意一下彩票下面直接是游戏*/
		],
	},
	2: {
		id: 2,
		name: "真人",
		link: "/peopleGame",
		api: [
			{
				game: 2,
				api: "ag",
				img: "peopleGame1",
				GameCode: "0",
				name: "AG女优厅",
				liveSummary: "全球唯一女优发牌,带来极致游戏体验",
			},
			{
				game: 3,
				api: "bb",
				img: "peopleGame2",
				GameCode: "lobby",
				name: "BB富贵厅",
				liveSummary: "亚洲最知名的游戏平台,五星信誉保障",
			},
			{
				game: 4,
				api: "og",
				img: "peopleGame3",
				GameCode: "21",
				name: "OG东方厅",
				liveSummary: "提供高品质高赔率娱乐游戏<br/>把满足用户需求放在第一位",
			},
			{
				game: 9,
				api: "ob",
				img: "peopleGame4",
				GameCode: "101",
				name: "欧博聚龙厅",
				liveSummary: "集合当下最受欢迎的视讯游戏<br/>致力公开公正公平的游戏平台",
			},
		],
	},
	3: {
		id: 3,
		name: "捕鱼",
		link: "/fishGame",
		api: [
			{ game: 2, api: "ag", img: "fishGame1", GameCode: "6", name: "捕鱼王" },
			{
				game: 12,
				api: "cq9",
				img: "fishGame2",
				GameCode: "AB3",
				name: "皇金渔场",
			},
			{
				game: 12,
				api: "cq9",
				img: "fishGame3",
				GameCode: "AB1",
				name: "皇金渔场2",
			},
			{
				game: 12,
				api: "cq9",
				img: "fishGame4",
				GameCode: "AT01",
				name: "一炮捕鱼",
			},
		],
	},
	4: {
		id: 4,
		name: "电子",
		link: "/ptGame",
		api: [
			{ game: 7, api: "pt", img: "ptGame1", GameCode: "", name: "PT电子" },
			{ game: 10, api: "bs", img: "ptGame2", GameCode: "", name: "BS电子" },
			{ game: 11, api: "mg", img: "ptGame3", GameCode: "", name: "MG电子" },
			{ game: 12, api: "cq9", img: "ptGame4", GameCode: "", name: "CQ9电子" },
			{ game: 13, api: "hb", img: "ptGame5", GameCode: "", name: "HABA电子" },
			{ game: 2, api: "AG", img: "ptGame6", GameCode: "", name: "AG电子" },
		],
	},
	5: {
		id: 5,
		name: "体育",
		link: "/sportGame",
		api: [
			{
				game: 17,
				api: "bd",
				img: "sportGame1",
				GameCode: "",
				name: "B8体育",
				plat: 1004,
				title: "",
				subTitle: "",
			},
			// {
			// 	game: 18,
			// 	api: "im",
			// 	img: "sportGame2",
			// 	GameCode: "",
			// 	name: "IM体育",
			// 	plat: 1005,
			// },
			{
				game: 15,
				api: "ss",
				img: "sportGame3",
				GameCode: "SC",
				name: "三昇体育",
			},
			{
				game: 5,
				api: "sb",
				img: "sportGame4",
				GameCode: "0",
				name: "沙巴体育",
			},
		],
	},
	6: {
		id: 6,
		name: "电竞",
		link: "/electron",
		api: [
			{
				game: 14,
				api: "fy",
				img: "electron1",
				GameCode: "lobby",
				name: "泛亚电竞",
			},
		],
	},
	7: {
		id: 7,
		name: "棋牌",
		link: "/qpGame",
		api: [{ game: 6, api: "ky", img: "qpGame1", GameCode: "0", name: "开元棋牌" }],
	},
};

export default apiTypeMap;



// WEBPACK FOOTER //
// ./src/store/apiTypeMap.js